

export const sortByName = (a: any,b: any) => a.name.localeCompare(b.name)
